import axios from 'axios';
import { API_URL } from './common';

interface SignupResponse {
  id: string;
  message: string;
}

interface LoginResponse {
  access_token: string;
  id: string;
}

const signup = async (
  loginId: string,
  username: string,
  email: string,
  password: string,
  googleId: string,
  profileImage: string
): Promise<SignupResponse> => {
  try {
    const response = await axios.post(`${API_URL}/api/v1/user/create`, {
      loginId,
      username,
      email,
      password,
      googleId,
      profileImage,
    });
    return response.data;
  } catch (error: any) {
    console.error('Signup error:', error.response?.data || error.message);
    throw error;
  }
};

const login = async (
  loginId: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const response = await axios.post(`${API_URL}/api/v1/auth/login`, {
      loginId,
      password,
    });
    return response.data;
  } catch (error: any) {
    console.error('Login error:', error.response?.data || error.message);
    throw error;
  }
};

const logout = (): void => {
  localStorage.removeItem('token');
  localStorage.removeItem('userId');
  sessionStorage.clear();
  window.location.href = '/';
};

// トークンの有効性をチェックする関数
const verifyToken = async (token: string): Promise<boolean> => {
  try {
    const response = await axios.get(`${API_URL}/api/v1/auth/verify`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    console.error('Token verification failed:', error);
    return false;
  }
};

// 現在のトークンを取得する関数
const getCurrentToken = (): string | null => {
  return localStorage.getItem('token');
};

// 現在のユーザーIDを取得する関数
const getCurrentUserId = (): string | null => {
  return localStorage.getItem('userId');
};

const authService = {
  signup,
  login,
  logout,
  verifyToken,
  getCurrentToken,
  getCurrentUserId,
};

export default authService;
